import * as moment from 'moment';
import { TDrawModel } from '../draw.model';
import { TIconConfig } from '../timeline.types';
import { TDate } from '@monorepo/types';

const DATE_FORMAT = 'YYYY-MM-DD';

export const DRAW_MODEL_UTILS = {
  getPostionByDate: (date: TDate, drawModel: TDrawModel) => {
    const dateMoment = moment.utc(date);
    const position = drawModel.scales.time(dateMoment.valueOf());
    return position;
  },
  getRangePosition: (
    range: TDrawModel['timelineModel']['entities'][number]['entities'][number]['elements'][number]['range'],
    drawModel: TDrawModel,
  ) => {
    const isWithoutTime = moment(range.endDate, DATE_FORMAT).format(DATE_FORMAT) === range.endDate;

    const startPosition = DRAW_MODEL_UTILS.getPostionByDate(range.startDate, drawModel);
    let endPosition = DRAW_MODEL_UTILS.getPostionByDate(range.endDate, drawModel);
    endPosition = endPosition + (isWithoutTime ? drawModel.layout.widthOfDay : 0);
    return [startPosition, endPosition] as const;
  },
  isOutOfRangeInTimeline: (
    range: TDrawModel['timelineModel']['entities'][number]['entities'][number]['elements'][number]['range'],
    drawModel: TDrawModel,
  ) => {
    const isStartInTimeline = moment(range.startDate).isSameOrBefore(drawModel.timelineModel.timeline[0]['date']);
    const isEndInTimeline = moment(range.endDate).isAfter(
      drawModel.timelineModel.timeline[drawModel.timelineModel.timeline.length - 1]['date'],
    );
    return [isStartInTimeline, isEndInTimeline];
  },
  getTooltipHTMLElements: (iconList: TIconConfig[]) => {
    const iconListHtml = iconList
      .map(
        (icon) => `
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"">
                    <rect x="0" y="0" width="22" height="22" fill="${icon.background || '#f8f9f9'}" rx="4"></rect>
                    <path d="${icon.svgPath}" fill="${icon.svgColor}" fill-rule="${icon.fillRule || 'nonzero'}"></path>
                  </svg>
                  `,
      )
      .join('');
    return iconListHtml;
  },

  calculateElementYPosition(
    element: TDrawModel['timelineModel']['entities'][number]['entities'][number]['elements'][number],
    drawModel: TDrawModel,
  ) {
    const delta = ((100 - (element.heightInPercent ?? 100)) * drawModel.layout.stackHeights[element.stackCount]) / 100;

    const reducedHeight = drawModel.layout.stackHeights.reduce(
      (acc, v, i) => (i <= element.stackCount ? acc + v : acc),
      0,
    );
    return drawModel.layout.entityHeight - reducedHeight + delta;
  },
};
